// Auto-generated normalizer for table: GENERAL.EmpresasUnidadesOrg
export function empresasUnidadesOrgNormalize(row) {
  return {
    idEmpresasUnidadesOrg:
      row.idEmpresasUnidadesOrg ??
      row.IdEmpresasUnidadesOrg ??
      row["idEmpresasUnidadesOrg"] ??
      row["IdEmpresasUnidadesOrg"] ??
      0,
    idEmpresa:
      row.idEmpresa ?? row.IdEmpresa ?? row["idEmpresa"] ?? row["IdEmpresa"] ?? 0,
    idUnidadOrganizacional:
      row.idUnidadOrganizacional ??
      row.IdUnidadOrganizacional ??
      row["idUnidadOrganizacional"] ??
      row["IdUnidadOrganizacional"] ??
      0,
    activo: row.activo ?? row.Activo ?? row["activo"] ?? row["Activo"] ?? true,
  };
}
